import { render, staticRenderFns } from "./ProductCategoryAttributesSimpleBlock.vue?vue&type=template&id=e8fc4332&scoped=true&"
import script from "./ProductCategoryAttributesSimpleBlock.vue?vue&type=script&lang=ts&"
export * from "./ProductCategoryAttributesSimpleBlock.vue?vue&type=script&lang=ts&"
import style0 from "./ProductCategoryAttributesSimpleBlock.vue?vue&type=style&index=0&id=e8fc4332&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8fc4332",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VIcon,VRow,VTextField,VTextarea,VTooltip})
